import $ from 'jquery'

/**
 * Close search page.
 */
export default function closeSearch () {
  const $closeButton = $('.js-close-search')
  const referer = $closeButton.data('referer')

  $closeButton.on('click', () => {
    if (referer) {
      window.location.href = referer
    } else {
      window.location.href = '/'
    }
  })
}
